const getSortingIndex = (category: MyBrokerApi.CategoryCounters) => {
    const sortId = parseInt(category.category.id, 10);
    return sortId < 0 ? 1000 : sortId;
};

export const sortCategories = (results: MyBrokerApi.CategoryCounters[]) => {
    return results
        ? results.sort((a, b) => {
              return getSortingIndex(a) - getSortingIndex(b);
          })
        : [];
};
